import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CampoObrigatorio} from '../../validators/campo-obrigatorio';
import {MSG_OBG_NOME_ADVOGADO, MSG_OBG_OAB_ADVOGADO} from '../../../../../tools/Mensagens';
import {AplicarRegraCampos} from '../../validators/aplicar-regra-campos';
import {CpeResponseDTO} from "../../../../../componentes/cpe-operador/dto/CpeResponseDTO";

@Component({
  selector: 'app-advogado-registro',
  templateUrl: './advogado-registro.component.html',
  styleUrls: ['./advogado-registro.component.css']
})
export class AdvogadoRegistroComponent implements OnInit {

  @Input() formulario: FormGroup;
  @Input() dados!: CpeResponseDTO;
  oabMaxLengthInput = 10;
  nomeMaxLength = 100;


  constructor() {
  }

  ngOnInit() {
    if (this.dados !== undefined) {
      const nomeAdvogadoValue = this.dados.nomeAdvogado ? this.dados.nomeAdvogado : '';
      const oabAdvogadoValue = this.dados.oabAdvogado ? this.dados.oabAdvogado : '';

      this.formulario.addControl('nomeAdvogado', new FormControl(nomeAdvogadoValue, Validators.maxLength(this.nomeMaxLength)));
      this.formulario.addControl('oabAdvogado', new FormControl(oabAdvogadoValue, Validators.maxLength(this.oabMaxLengthInput)))
    }else{
      this.formulario.addControl('nomeAdvogado', new FormControl('', Validators.maxLength(this.nomeMaxLength)));
      this.formulario.addControl('oabAdvogado', new FormControl('', Validators.maxLength(this.oabMaxLengthInput)))
    }

  }


  ngOnDestroy() {
    this.formulario.removeControl('nomeAdvogado');
    this.formulario.removeControl('oabAdvogado');

  }

  public validarFormulario() {
    const campos = [
      {control: 'nomeAdvogado', mensagem: MSG_OBG_NOME_ADVOGADO, regra: this.validarNome.bind(this)},
      {control: 'oabAdvogado', mensagem: MSG_OBG_OAB_ADVOGADO, regra: this.validarOab.bind(this)}
    ];
    AplicarRegraCampos.aplicar(campos, this.formulario);
  }

  private validarNome(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }

  private validarOab(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }
}
